<template>
<div>
	<div class="role">
		<el-button @click="showDialog('add')" class="add qjc-fts-16">添加优惠码</el-button>
		<el-button class="add qjc-fts-16" @click="showDialog2('add')">批量生成优惠码</el-button>
		<div class="qjc-flex query-wrap">
			<div class="query-title">优惠码：</div>
			<el-input class="search-input" v-model="dis_code" placeholder="请输入优惠码">
				<div class="search-icon" slot="prefix">
					<i class="el-icon-search"></i>
				</div>
			</el-input>
			<div class="query-title">状态：</div>
			<el-select v-model="used" class="query-package" @change="handleChangeUsed">
				<el-option 
					v-for="item in usedList2"
					:key="item.id"
					:label="item.name"
					:value="item.id"
				></el-option>
			</el-select>
			<el-button @click="handleQuery" class="query-btn qjc-fts-16">查询</el-button>
			<el-button @click="handleRet" class="query-btn qjc-fts-16">重置</el-button>
		</div>
		
		
		<el-table
			:data="list"
			style="width: 100%"
		>
			<template slot="empty">
				<div class="empty-wrap">
					<el-image class="empty-img" :src="require('@/assets/images/empty-history.png')"></el-image>
					<div class="empty-text">暂无数据</div>
				</div>
			</template>
			<el-table-column
				label="编号"
				prop="id"
				min-width="60"
			></el-table-column>
			<el-table-column
				label="优惠码"
				prop="code"
				min-width="120"
			>
				<template slot-scope="scope">
					<div class="" v-if="scope.row.sn">{{scope.row.sn ? scope.row.sn : ''}}</div>
					<div class="">{{scope.row.code}}</div>
				</template>
			</el-table-column>
			<el-table-column
				label="适用产品"
				prop="goods_name"
				min-width="200"
			>
				<template slot-scope="scope">
					AI智慧健康管家
				</template>
			</el-table-column>
			<el-table-column
				label="有效期至"
				prop="exp"
				min-width="180"
			>
				<template slot-scope="scope">
					<div class="">{{scope.row.exp ? scope.row.exp : '--'}}</div>
				</template>
			</el-table-column>
			<el-table-column
				label="有效次数"
				prop="times"
				min-width="100"
			>
				<template slot-scope="scope">
					<div class="">{{scope.row.times == 0 ? '无限制' : scope.row.times}}</div>
				</template>
			</el-table-column>
			<el-table-column
				label="已用次数"
				prop="used"	
				min-width="100"
			>
				<template slot-scope="scope">
					<div class="">{{scope.row.used}} <span class="user_btn" v-if="scope.row.used > 0" @click="handleToRecord(scope.row.id)">查看</span></div>
				</template>
			</el-table-column>
			<el-table-column
				label="备注"
				prop="remark"
				min-width="160"
			>
				<template slot-scope="scope">
					<div class="" v-if="remarkId == scope.row.id">
						<el-input v-model="newRemark" placeholder="请输入备注" @keyup.enter.native="handleNewRemark(scope.row.id)" @blur="handleBlur"></el-input>
					</div>
					<div class="" v-else :title="scope.row.remark">{{scope.row.remark ? scope.row.remark : ''}} <i @click="handleRemarkId(scope.row.id)" class="el-icon-edit"></i></div>
					
				</template>
			</el-table-column>
			<el-table-column
				label="状态"
				prop="status"
			>
				<template slot-scope="scope">
					<el-switch
						@change="handleStatus(scope.row)"
						v-model="scope.row.status"
						active-value="1"
						inactive-value="2"
						active-color="#38E019"
						inactive-color="#FF5219">
					</el-switch>
				</template>
			</el-table-column>
			<el-table-column
				label="操作日期"
				prop="updated_at"
				min-width="160"
			>
				<template slot-scope="scope">
					<div class="">{{scope.row.updated_at ? scope.row.updated_at : '--'}}</div>
				</template>
			</el-table-column>
			
		</el-table>

		
		
		<!-- 分页 -->
		<el-pagination
			@current-change="pageChange"
			:current-page.sync="pager.page"
			hide-on-single-page
			:page-size="pager.pagesize"
			
				prev-text="上一页"
				next-text="下一页"
				layout="total, prev, pager, next,jumper"
			:total="pager.count">
		</el-pagination>
		<!-- 添加、修改弹窗 -->
		<el-dialog 		  :close-on-click-modal="false"
		  :title="(oper == 'add'?'添加':(oper == 'edit'?'修改':'')) + '优惠码'"
		  :visible.sync="isAlert"
		  :before-close="formCancel"
		  width="50%" >
			<el-form
				:model="formData"
				:rules="rules"
				ref="form"
			>
				<el-form-item
					label="优惠码"
					prop="code"
				>
					<div class="code_cell">
						<el-input
							v-model="formData.code"
							onkeyup="this.value=this.value.replace(/[^\w_\d{0,8}]/g,'');"
							maxlength="8"
							placeholder="请输入"
						></el-input>
						<div class="code_btn" @click="handleCode">随机生成</div>
					</div>
					
				</el-form-item>
				
				
				<el-form-item
					label="有效期至"
					prop="exp"
				>
					<el-date-picker
						v-model="formData.exp"
						type="date"
						value-format="yyyy-MM-dd"
						:picker-options="pickerOptions"
						placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item
					label="有效次数"
					prop="times"
				>
				<div class="times_cell">
					<el-input
						v-model="formData.times"
						placeholder="请输入"
						type="number"
						:disabled="noTimes"
					></el-input>
					<el-checkbox :class="noTimes ? 'noTimes active' : 'noTimes'" v-model="noTimes">无限制</el-checkbox>
				</div>
				</el-form-item>
				<el-form-item
					label="是否启用"
					prop="status"
				>
					<el-switch
					  v-model="formData.status"
					  active-color="#38E019"
					  inactive-color="#FF5219">
					</el-switch>
				</el-form-item>
				<el-form-item
					label="备注"
					prop="remark"
				>
					<el-input
						v-model="formData.remark"
						placeholder="请输入"
					></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button class="cancel-btn" @click="formCancel">取消</el-button>
				<el-button class="submit-btn" @click="formSubmit">提交</el-button>
			</span>
		</el-dialog>
		
		<el-dialog 		  :close-on-click-modal="false"
		  title="批量生成优惠码"
		  :visible.sync="isAlert2"
		  width="50%"
		  :before-close="formCancel2" >
			<el-form
				:model="formData2"
				:rules="rules2"
				ref="form2"
			>
				<el-form-item
					label="序列号规则"
					prop="sn"
				>
					<div class="code_cell">
						<el-input
							v-model="formData2.sn"
							type="number"
							placeholder="请输入"
						></el-input>
					</div>
					
				</el-form-item>
				<el-form-item
					label="添加个数"
					prop="num"
				>
					<div class="code_cell">
						<el-input
							v-model="formData2.num"
							type="number"
							placeholder="请输入"
						></el-input>
					</div>
					
				</el-form-item>
				
				<el-form-item
					label="有效期至"
					prop="exp"
				>
					<el-date-picker
						v-model="formData2.exp"
						type="date"
						value-format="yyyy-MM-dd"
						:picker-options="pickerOptions"
						placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item
					label="有效次数"
					prop="times"
				>
				<div class="times_cell">
					<el-input
						v-model="formData2.times"
						placeholder="请输入"
						type="number"
						:disabled="noTimes"
					></el-input>
					<el-checkbox :class="noTimes ? 'noTimes active' : 'noTimes'" v-model="noTimes">无限制</el-checkbox>
				</div>
				</el-form-item>
				<el-form-item
					label="是否启用"
					prop="status"
				>
					<el-switch
					  v-model="formData2.status"
					  active-color="#38E019"
					  inactive-color="#FF5219">
					</el-switch>
				</el-form-item>
				<el-form-item
					label="备注"
					prop="remark"
				>
					<el-input
						v-model="formData2.remark"
						placeholder="请输入"
					></el-input>
				</el-form-item>
			</el-form>
			
			<span slot="footer">
				<div class="dialog-footer">
					<el-button class="cancel-btn" @click="formCancel2">取消</el-button>
					<el-button class="submit-btn" @click="formSubmit2">提交</el-button>
				</div>
				
				<p class="tips_p">序列号规则: 一共12位</p>
				<p class="tips_p">序列号规则从100000000001开始，个数为20个，则生成序列号依次为100000000001、100000000002...100000000020</p>
				<!-- <p class="tips_p">首四位按批次从1000开始顺序加一，例如第一批为1000，第二批为1001</p>
				<p class="tips_p">中间四位为（地区码，0，产品编号），大陆地区码为1，香港为2，例如大陆AI智慧健康为1001，大陆尊贵白金为1002，香港AI智慧健康为2001</p>
				<p class="tips_p">最后四位为卡编号，顺序编码</p> -->
			</span>
		</el-dialog>
	</div>
	<el-dialog 		  :close-on-click-modal="false"
		  title="批量生成优惠码"
		  :visible.sync="isAlert3"
		  width="50%"
		  :before-close="formCancel3" >
			<el-form
				:model="formData3"
				:rules="rules3"
				ref="form3"
			>
				<el-form-item
					label="序列号开始"
					prop="sn1"
				>
					<div class="code_cell">
						<el-input
							v-model="formData3.sn1"
							type="number"
							placeholder="请输入"
						></el-input>
					</div>
					
				</el-form-item>
				<el-form-item
					label="序列号结束"
					prop="sn2"
				>
					<div class="code_cell">
						<el-input
							v-model="formData3.sn2"
							type="number"
							placeholder="请输入"
						></el-input>
					</div>
				</el-form-item>
			</el-form>
			<span slot="footer">
				<div class="dialog-footer">
					<el-button class="cancel-btn" @click="formCancel3">取消</el-button>
					<el-button class="submit-btn" @click="formSubmit3">下载</el-button>
				</div>
			</span>
		</el-dialog>
	
	<el-dialog 		  :close-on-click-modal="false"
	  title="优惠码使用记录"
	  :visible.sync="isUsedShow"
	  width="60%" 
	  class="used_dialog">
		  <el-table
			:data="usedList"
			style="width: 100%"
		  >
			<template slot="empty">
				<div class="empty-wrap">
					<el-image class="empty-img" :src="require('@/assets/images/empty-history.png')"></el-image>
					<div class="empty-text">暂无数据</div>
				</div>
			</template>
			<el-table-column
				label="编号"
				prop="id"
				width="80"
			></el-table-column>
			<el-table-column
				label="优惠码"
				prop="code"
			></el-table-column>
			<el-table-column
				label="手机号"
				prop="mobile"
			></el-table-column>
			<el-table-column
				label="使用时间"
				prop="created_at"
			></el-table-column>
			<el-table-column
				label="订单编号"
				prop="order_no"
			></el-table-column>
		  </el-table>
		  
		  <!-- 分页 -->
		  <el-pagination
			@current-change="pageChange2"
			:current-page.sync="pager2.page"
			hide-on-single-page
			:page-size="pager2.pagesize"
			
				prev-text="上一页"
				next-text="下一页"
				layout="total, prev, pager, next,jumper"
			:total="pager2.count">
		  </el-pagination>
	</el-dialog>
	
</div>
</template>

<script>
	import { getSxCoupon, getGoodsList } from '@/utils/axios.js';
	import { dateStrChangeTimeTamp } from '@/utils';
	
	export default {
		name: 'sxDiscount',
		data() {
			var powerVerify = (rule, value, callback) => {
				if(this.noTimes) {
					callback();
				} else if(!this.noTimes && this.formData.times <= 0) {
					callback(new Error('请输入有效次数'));
				}
				callback();
			}
			var powerVerify2 = (rule, value, callback) => {
				if(this.noTimes) {
					callback();
				} else if(!this.noTimes && this.formData2.times <= 0) {
					callback(new Error('请输入有效次数'));
				}
				callback();
			}
			return {
				submiting: false, // 正在请求
				list: [], //列表
				usedList: [],
				id: '',
				dis_code: '',
				packageList: [],
				usedList2: [
					{
						id: 0,
						name: '全部'
					},{
						id: 1,
						name: '已使用'
					},{
						id: 2,
						name: '未使用'
					}
				],
				used: 0,
				pager: {
					count: 0, // 总条数
					page: 1, // 当前页
					pagecount: 0, // 总页数
					pagesize: 10 // 每页条数
				},
				pager2: {
					count: 0, // 总条数
					page: 1, // 当前页
					pagecount: 0, // 总页数
					pagesize: 8 // 每页条数
				},
				isAlert: false,
				isAlert2: false,
				oper: '',
				formData: {
					code: '',
					remark: '',
					exp: '',
					times: '',
					status: false,
				},
				formData2: {
					sn: '',
					num: '',
					remark: '',
					exp: '',
					times: '',
					status: false,
				},
				rules2: {
					sn: [
						{ required: true, message: '请输入序列号', trigger: 'blur' }
					],
					num: [
						{ required: true, message: '请输入添加个数', trigger: 'blur' }
					],
					exp: [
						{ required: true, message: '请选择有限时间', trigger: 'change' }
					],
					times: [
						{ required: true, message: '请输入有效次数', trigger: 'blur' },
						{ validator: powerVerify2, trigger: 'blur' }
					],
					remark: [
						{ required: false, message: '请输入备注', trigger: 'change' }
					],
					status: [
						{ required: false, message: '请选择启用状态', trigger: 'blur' }
					],
				},
				formData3: {
					sn1: '',
					sn2: '',
					act: 'coupon',
				},
				rules3: {
					sn1: [
						{ required: true, message: '请输入开始序列号', trigger: 'blur' }
					],
					sn2: [
						{ required: true, message: '请输入结束序列号', trigger: 'blur' }
					],
				
				},
				sn1: '',
				sn2: '',
				
				oper2: '',
				disc: '',
				downAct: 'coupon',
				isAlert3: false,
				remarkId: '',
				newRemark: '',
				isUsedShow: false,
				typeOptions: [{
						value: '2',
						label: '优惠金额',
					},{	
						value: '1',
						label: '固定金额',
					},{
						value: '3',
						label: '优惠折扣',
					},
				],
				packageOptions: [],
				rules: {
					code: [
						{ required: true, message: '请输入优惠码', trigger: 'blur' }
					],
					exp: [
						{ required: true, message: '请选择有限时间', trigger: 'change' }
					],
					times: [
						{ required: true, message: '请输入有效次数', trigger: 'blur' },
						{ validator: powerVerify, trigger: 'blur' }
					],
					remark: [
						{ required: false, message: '请输入备注', trigger: 'change' }
					],
					status: [
						{ required: false, message: '请选择启用状态', trigger: 'blur' }
					],
				},
				noTimes: false,
				pickerOptions: {
					disabledDate(time) { // 结束时间禁用时间段
					  // 设置可选择的日期为今天之后的一个月内
						const curDate = (new Date()).getTime()
						return time.getTime() < curDate
					},
				}
			};
		},
	
		mounted() {
			this.getList();
			this.handleGoodsList();
		},
		components: {},
		watch: {
			noTimes(newVal, oldVal) {
				if(newVal){
					this.formData.times = 0;
					this.$refs.form.validateField("times")
				}
			},
		},
		methods: {
			handlePackage(e) {
				
			},
			handleChangeSelect(e) {
				
			},
			handleChangeUsed(e) {
				
			},
			formSubmit3() {
				this.$refs.form3.validate(isSuc => {
					if(isSuc){
						this.$refs.down.click();
						this.isAlert3 = false
						
					}
				
				})
			},
			handleToRecord(id) {
				this.pager2 = {
					count: 0, // 总条数
					page: 1, // 当前页
					pagecount: 0, // 总页数
					pagesize: 8 // 每页条
				}
				let data = {...this.pager2, id};
				this.id = id;
				data.act = "usedList";
				this.getusedList(data);
				this.isUsedShow = true;
			},
			handleCode() {
				getSxCoupon({act: 'code'}).then((res) => {
					if(res.code == 200) {
						this.formData.code = res.data.code;
						this.$refs.form.validateField("code")
					} else {
						this.$myAlert({
							type: 'fail',
							title: res.msg
						});
					}
				})
			},
			handleRemarkId(id) {
				this.remarkId = id;
			},
			handleBlur() {
				this.remarkId = '';
			},
			handleNewRemark(id) {
				if(this.newRemark.trim() != '') {
					this.$myAlert({
						title: '确定修改？',
						callback: () => {// 点击确认触发
							getSxCoupon({act: 'remark', id: id, remark: this.newRemark}).then((res) => {
								if(res.code == 200) {
									this.isAlert = false;
									this.remarkId = '';
									this.newRemark = '';
									this.getList();
								} else {
									this.$myAlert({
										type: 'fail',
										title: res.msg
									});
								}
							})
						}
					});
				} else {
					this.$myAlert({
						type: 'fail',
						title: '请输入备注',
						callback: () => {// 点击确认触发
							this.remarkId = '';
							this.newRemark = '';
						}
					});
				}
			},
			handleGoodsList() {
				getGoodsList().then((res) => {
					if(res.code == 200) {
						let goodsList = JSON.parse(window.atob(res.data))
						let list = []
						let list2 = []
						goodsList.map((goods) => {
							list.push({
								value: goods.id,
								label: goods.name,
								price: goods.price
							})
							list2.push({
								id: goods.id,
								name: goods.name
							})
						})
						list2.unshift({
							id: '',
							name: '全部套餐'
						})
						this.packageList = list2
						
						this.packageOptions = list
					}
				})
			},
			handleStatus(val) {
				getSxCoupon({act: 'status', id: val.id, status: val.status == 2 ? 0 : val.status}).then((res) => {
					if(res.code == 200) {
						this.getList();
					} else {
						this.$myAlert({
							type: 'fail',
							title: res.msg
						});
					}
				})
			},
			handleQuery() {
				this.pager.page = 1;
				this.getList()
			},
			handleRet() {
				this.dis_code = '';
				this.used = 0;
				this.pager.page = 1;
				this.getList()
			},
			// 获取列表
			getList() {
				let data = {
					code: this.dis_code,
					used: this.used,
					page: this.pager.page, // 当前页
					pagesize: this.pager.pagesize // 每页条
				}
				getSxCoupon(data).then(res => {
					if(res.code == 200){
						this.list = res.data.data;
						this.pager = res.data.pager;
						
						// 数值可能为字符串，需转换为number
						for(var key in this.pager){
							this.pager[key] = parseInt(this.pager[key]);
						}
						
					}else{
						this.$myAlert({
							type: 'fail',
							title: res.msg
						});
					}
				});
			},
			getusedList(data) {
				getSxCoupon(data).then(res => {
					if(res.code == 200){
						this.usedList = res.data.data;
						this.pager2 = res.data.pager;
						
						// 数值可能为字符串，需转换为number
						for(var key in this.pager2){
							this.pager2[key] = parseInt(this.pager2[key]);
						}
						
					}else{
						this.$myAlert({
							type: 'fail',
							title: res.msg
						});
					}
				});
			},
			pageChange(page) {
				this.pager.page = page;
				this.getList();
			},
			pageChange2(page) {
				this.pager2.page = page;
				let data = {...this.pager2};
				data.id = this.id;
				data.act = "usedList";
				this.getusedList(data);
			},
			showDialog(oper, id) {
				this.oper = oper;
				this.isAlert = true;
				this.handleGoodsList();
			},
			showDialog2 (oper, id) {
				this.oper2 = oper;
				this.isAlert2 = true;
				this.handleGoodsList();
			},
			formSubmit() {
				let rex = /^[a-zA-Z0-9]{8}$/
				if(!rex.test(this.formData.code)) {
					this.$myAlert({
						type: 'fail',
						title: '优惠码为8位数字或字母'
					});
					
					return
				}
				this.$refs.form.validate(isSuc => {
					if(isSuc){
						let data = {...this.formData};
						data.act = 'add';
						data.exp = dateStrChangeTimeTamp(data.exp);
						getSxCoupon(data).then((res) => {
							if(res.code == 200) {
								this.isAlert = false;
								this.noTimes = false;
								this.$refs.form.resetFields();
								this.$myAlert({
									type: 'success',
									title: (this.oper == 'add'?'添加':'修改')+'成功'
								});
								this.getList();
							} else {
								this.$myAlert({
									type: 'fail',
									title: res.msg
								});
							}
						})
						
						
					}
				
				})
			},
			formSubmit2() {
				this.$refs.form2.validate(isSuc => {
					if(isSuc){
						let data = {...this.formData2};
						data.act = 'batchAdd';
						data.exp = dateStrChangeTimeTamp(data.exp);
						getSxCoupon(data).then((res) => {
							if(res.code == 200) {
								this.isAlert2 = false;
								this.noTimes = false;
								this.$refs.form2.resetFields();
								this.$myAlert({
									type: 'success',
									title: res.msg
								});
								this.getList();
							} else {
								this.$myAlert({
									type: 'fail',
									title: res.msg
								});
							}
						})
						
						
					}
				
				})
			},
			formCancel() {
				this.$refs.form.resetFields();
				this.noTimes = false;
				this.isAlert = false;
				this.isAlert2 = false;
			},
			formCancel2() {
				this.$refs.form2.resetFields();
				this.noTimes = false;
				this.isAlert = false;
				this.isAlert2 = false;
			},
			formCancel3() {
				this.$refs.form3.resetFields();
				this.isAlert3 = false;
			},
			handleDel(id) {
				this.$myAlert({
					title: '确定删除？',
					callback: () => {// 点击确认触发
						// getCoupon({act: 'del', id: id}).then((res) => {
						// 	if(res.code == 200) {
								
						// 		this.isAlert = false;
						// 		this.noTimes = false;
						// 		this.$refs.form.resetFields();
						// 	} else {
						// 		this.$myAlert({
						// 			type: 'fail',
						// 			title: res.msg
						// 		});
						// 	}
						// })
					}
				});
			},
		}
	};
</script>

<style scoped>
	.el-dialog .el-form .el-form-item >>>  .code_cell .el-input__inner {
		padding-right: 80px !important;
	}
	.el-dialog .el-form .el-form-item >>> .el-date-editor.el-input, .el-dialog .el-form .el-form-item >>> .el-date-editor.el-input__inner {
		width: 100%;
	}
	.el-dialog .el-form .el-form-item >>> .el-select {
		width: 100%;
	}
	.el-dialog .el-form >>> .el-form-item {
		margin-bottom: 8px;
	}
	.el-dialog .el-form >>> .el-form-item__label{
		width: 16%;
		padding-right: 24px;
		margin-left: 4%;
		text-align: right;
	}
	.el-dialog .el-form >>> .el-form-item__content{
		float: left;
		width: 60%;
		margin-right: 0;
	}
	.query-wrap {
		margin: 12px 0;
	}
	.query-wrap >>> .el-input__inner {
		height: 36px;
		line-height: 36px;
	}
	.right-wrap >>> .el-checkbox__input.is-checked+.el-checkbox__label {
		color: #6681FA;
	}
	.right-wrap >>> .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #6681FA;
		border-color: #6681FA;
	}
	.right-wrap >>> .el-switch__core:after {
		background-color: #828DBC;
	}
	.right-wrap >>> .el-switch.is-checked .el-switch__core::after {
		background-color: #6681FA;	
	}
	.right-wrap >>> .el-input-number__increase {
		display: none;
	}
	.right-wrap >>> .el-input-number__decrease {
		display: none;
	}
	.right-wrap .input-number >>> .el-input__inner {
		height: 30px;
		border: none;
		border-bottom: 1px solid #CED4F0;
		border-radius: 0;
		padding: 0;
		margin-left: 10px;
	}
	.used_dialog >>> .el-dialog__body {
		padding: 0 20px 30px;
	}
	::v-deep input::-webkit-outer-spin-button,::v-deep input::-webkit-inner-spin-button{
	  -webkit-appearance: none !important;
	}
	::v-deep input[type='number']{
	  line-height: 1;
	  -moz-appearance: textfield !important;
	}
	
</style>
<style lang="scss" scoped>
	.search-input {
		width: 258px;
		height: 34px;
		margin-right: 20px;
	}
	.query-package {
		margin-right: 20px;
	}
	.query-title {
		display: flex;
		align-items: center;
	}
	.search-icon {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 26px;
		height: 36px;
	}
	.query-btn {
		width: 72px;
		height: 36px;
		line-height: 36px;
		font-size: 15px;
		padding: 0;
		margin-left: 16px;
		border: none;
		color: #fff;
	}
	.role{
		// display: flex;
		width: 100%;
		height: 100%;
		padding: 24px 24px;
		
		.left-menus {
			min-width: 170px;
			width: 170px;
			padding: 30px 24px;
			border-right: 1px solid #E5E8F5;
			background-color: #ffffff;
			
			.add-action {
				display: flex;
				align-items: center;
				cursor: pointer;
				
				.add-action-img {
					display: flex;
					align-items: center;
					align-items: center;
					width: 24px;
					height: 24px;
					background-color: #6883FB;
					border-radius: 50%;
					
					&::after {
						content: "+";
						width: 100%;
						font-size: 20px;
						color: #fff;
						text-align: center;
						margin-bottom: 4px;
					}
				}
				.add-action-text {
					font-size: 14px;
					color: #6883FB;
					margin-left: 8px;
				}
			}
			.left-list {
				padding-top: 20px;
			}
			
			.left-enp-item {
				padding: 12px 0;
				font-size: 15px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #525866;
				line-height: 20px;
				cursor: pointer;
			}
			.left-enp-item-active {
				padding: 12px 0;
				font-size: 15px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 500;
				color: #6883FB;
				line-height: 20px;
			}
		}
		
		.right-wrap {
			flex: 1;
			padding: 36px 24px;
			overflow: auto;
			
			.right-temp {
				margin-bottom: 32px;
				
				.temp-title {
					display: flex;
					align-items: center;
					justify-content: space-between;
					font-size: 18px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #293033;
					line-height: 24px;
					padding-bottom: 10px;
					border-bottom: 1px solid #E5E8F5;
				}
				
				.temp-info {
					margin-top: 12px;
				}
			}
			
			.submit-btn {
				width: 94px;
				height: 34px;
				font-size: 15px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #FFFFFF;
				line-height: 34px;
				background-color: #6883FB;
				border-radius: 17px;
				border: none;
				margin-top: 10px;
			}
			.info-cell {
				margin-bottom: 20px;
			}
			.input-number {
				width: 50px;
			}
			.custom-info {
				position: relative;
				width: 670px;
				padding: 24px;
				border: 1px solid #CED4F0;
				border-radius: 4px;
				margin-top: 10px;
				
				&::before {
					box-sizing: content-box;
					position: absolute;
					width: 0;
					height: 0;
					top: -16px;
					left: 41px;
					padding: 0;
					border-top: 8px solid transparent;
					border-left: 8px solid transparent;
					border-right: 8px solid transparent;
					border-bottom: 8px solid #fff;
					display: block;
					content: '';
					z-index: 12;
				}
				
				&::after {
					box-sizing: content-box;
					position: absolute;
					width: 0;
					height: 0;
					top: -18px;
					left: 40px;
					padding: 0;
					border-top: 9px solid transparent;
					border-left: 9px solid transparent;
					border-right: 9px solid transparent;
					border-bottom: 9px solid #CED4F0;
					display: block;
					content: '';
					z-index: 10;
				}
			}
			.custom-group {
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				
				.custom-item {
					display: flex;
					align-items: center;
					justify-content: space-between;
					width: 30%;
					margin-right: 20px;
				}
			}
		}
		
		.add{
			padding: 8px 12px;
			color: #fff;
		}
		
		.el-table{
			i[class^=el-icon]{
				margin-right: 16px;
				cursor: pointer;
			}
		}
		
		.el-pagination{
			text-align: center;
			margin-top: 32px;
		}
		
		.el-dialog{
			
			.dialog-title {
				font-size: 18px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #293033;
				text-align: center;
			}
			.all-power{
				-webkit-appearance: none;
				background-color: #FFF;
				background-image: none;
				border-radius: 4px;
				border: 1px solid #DCDFE6;
				box-sizing: border-box;
				color: #606266;
				display: inline-block;
				font-size: inherit;
				height: 40px;
				line-height: 40px;
				outline: 0;
				padding: 0 15px;
				transition: border-color .2s cubic-bezier(.645,.045,.355,1);
				width: 100%;
			}
			.dialog-footer{
				display: flex;
				align-items: center;
				justify-content: center;
				.cancel-btn {
					width: 94px;
					height: 34px;
					font-size: 14px;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #6883FB;
					border: 1px solid #6883FB;
					border-radius: 17px;
					background-color: #fff;
				}
				.submit-btn {
					width: 94px;
					height: 34px;
					font-size: 14px;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #fff;
					border: none;
					border-radius: 17px;
					background-color: #6883FB;
					margin-left: 16px;
				}
				.el-button{
					padding: 9px 15px;
				}
			}
		}
	}
	
	.quota_cell {
		position: relative;
		display: flex;
		align-items: center;
		
		.unit {
			position: absolute;
			right: 10px;
			top: 0px;
		}
	}
	.times_cell {
		display: flex;
		align-items: center;
		
		.noTimes {
			height: 40px;
			padding: 0 12px;
			margin-left: 10px;
			border: 1px solid #DCDFE6;
			border-radius: 4px;
		}
		.active {
			border: 1px solid #6681FA;
		}
	}
	.empty-wrap {
		padding: 100px 0;
	}
	.empty-img {
		width: 338px;
		height: 218px;
	}
	.code_cell {
		position: relative;
		display: flex;
		align-items: center;
		
		input {
			padding-right: 80px;
		}
		
		.code_btn {
			position: absolute;
			top: 0;
			right: 20px;
			font-size: 14px;
			font-family: PingFang SC-Light, PingFang SC;
			font-weight: 300;
			color: #6883FB;
			cursor: pointer;
			z-index: 99;
		}
	}
	
	.el-icon-edit {
		color: #6681FA;
	}
	
	.user_btn {
		color: #6681FA;
		cursor: pointer;
	}
	
	.el-pagination{
		text-align: center;
		margin-top: 32px;
	}
	
	.tips_p {
		font-size: 14px;
		padding: 0 78px;
		margin-bottom: 10px;
		text-align: left;
		
	}
</style>